import { render } from "./CompanyActive.vue?vue&type=template&id=38abd990"
import script from "./CompanyActive.vue?vue&type=script&setup=true&lang=js"
export * from "./CompanyActive.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Admin/Company/CompanyActive.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "38abd990"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('38abd990', __exports__)) {
    api.reload('38abd990', __exports__)
  }
  
  module.hot.accept("./CompanyActive.vue?vue&type=template&id=38abd990", () => {
    api.rerender('38abd990', render)
  })

}


export default __exports__